import { Breakpoints } from '@apps/gated-2021/breakpoints';
import styled from 'styled-components';
import { Button as DefaultButton } from './button';
import { Back } from './form.styled';

export const BackButton = styled(Back)``;

export const Button = styled(DefaultButton)`
    margin: 0 auto 0 0;

    span {
        @media screen and (max-width: ${Breakpoints.mobile}) {
            display: none;
        }
    }
`;
